/* eslint-disable */

<template>
  <div class="vx-col">
    <vx-card class="mb-base">
      <div class="tenth-block-2 rounded" style="background-color: #5A9E5C;">
        <div class="tenth-image-block-2" style="background-color: #5A9E5C;">
          <img draggable="false" style="display: inline; padding-top: 10px;" src="https://cdn.discordapp.com/attachments/870877265506992240/944642949768183828/location.png" width="30"><h1 class="tenth-block-text-small-2">&nbsp; 1500 Broadway, New York, NY 10036<br></h1></div>
      </div>
      <div>
        <h6>&nbsp;</h6>
      </div>
      <div class="" style="border: 8px solid #FFF; border-radius: 10px; padding: 20px">
        <div class="simulation-10">

          <div class="columns-13 w-sim-legacy-row">
            <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
              <div class="tenth-public-network-2 rounded" @click="wifi_controller.active = !wifi_controller.active">
                <div class="tenth-public-network-bottom-2 ">
                  <div class="tenth-block rounded">
                    <div class="tenth-image-block"><img draggable="false"
                                                        alt="" class="tenth-image"
                                                        src="https://logos-world.net/wp-content/uploads/2021/08/Cisco-Logo.png"
                                                        width="100"></div>
                    <h1 class="tenth-block-text-small">Cisco 5520<br>WLAN Controller<br></h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-sim-legacy-col w-sim-legacy-col-3"/>
            <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
              <div class="tenth-internet-block-2 rounded">
                <div class="tenth-image-block"><img draggable="false" alt=""
                                                    class="tenth-image"
                                                    src="https://rapidsimulations.com/simulations/1/images/global.png"
                                                    width="60"></div>
                <h1 class="tenth-internet-text">Internet</h1>
              </div>
            </div>
            <div class="w-sim-legacy-col w-sim-legacy-col-3"/>
          </div>

          <div class="columns-13 w-sim-legacy-row">
            <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
              <div class="line-internet-up"></div>
              <div class="internet-connect-right-line"></div>
            </div>
            <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">

              <div class=" rounded" style="">
                <div class="tenth-image-block"><img draggable="false"
                                                    alt="" class=""
                                                    src="https://cdn.discordapp.com/attachments/870877265506992240/944401147538595840/sbstore.png"
                                                    width="350"></div>
              </div>
            </div>
            <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
              <div class="tenth-firewall-block-2" style="background-color: #4169e1">
                <div class="tenth-image-block"><img draggable="false" alt=""
                                                    class="tenth-image"
                                                    src="https://cdn.discordapp.com/attachments/870877265506992240/944410617803046932/pawn-parent-brand-primary-logo-rgb.png"
                                                    width="150"></div>
                <h1 class="tenth-internet-text">Paloalto NGFW<br>Appliance</h1>
              </div>
              <div class="line-internet-up"></div>
            </div>
            <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
              <div class="tenth-server rounded bg-danger" @click="wireless_client.active = !wireless_client.active">
                <div class="tenth-public-network-bottom-2 rounded">
                  <div class="tenth-block rounded">
                    <div class="tenth-image-block"><img draggable="false"
                                                        alt="" class="tenth-image"
                                                        src="https://cdn.discordapp.com/attachments/870877265506992240/944409408551678002/wifi.png"
                                                        width="50"></div>
                    <h1 class="tenth-block-text-small">Starbucks Employee<br>BYOD Mobile Device</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="columns-13 w-sim-legacy-row">
            <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3">
              <div class="tenth-public-network-bottom-2 rounded" @click="radius_server.active = !radius_server.active">
                <div class="tenth-public-network-2 rounded">
                  <div class="tenth-block rounded">
                    <div class="tenth-image-block"><img draggable="false"
                                                        alt="" class="tenth-image"
                                                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Juniper_Networks_logo.svg/2560px-Juniper_Networks_logo.svg.png"
                                                        width="100"></div>
                    <h1 class="tenth-block-text-small">Juniper Networks<br>AAA Server</h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-sim-legacy-col w-sim-legacy-col-3"/>
            <div class="center-2 w-sim-legacy-col w-sim-legacy-col-3 bg">
              <div class="tenth-internet-block-2 bg-warning rounded">
                <div class="tenth-image-block"><img draggable="false" alt=""
                                                    class="tenth-image"
                                                    src="https://cdn.discordapp.com/attachments/746242308084858900/810307353843859486/wireless-access-point.png"
                                                    width="60"></div>
                <h1 class="tenth-internet-text">Starbucks Staff<br>BYOD WiFi Router</h1>
              </div>
            </div>
            <div class="w-sim-legacy-col w-sim-legacy-col-3"/>
          </div>

        </div>
      </div>
    </vx-card>

    <movable-popup refVal="movableWiFiControllerRef" title="Cisco 5520 WLAN Controller - Drag Here To Move"
                   :active="wifi_controller.active" v-on:close="wifi_controller.active = false">
      <template v-slot:content>
        <div v-for="field in wifi_controller.properties" :key="field.name" class="vx-row mb-3 mt-3">
          <div class="vx-col flex w-1/3">
            <h3 class="break-words self-center">{{ field.name }}</h3>
          </div>
          <div class="vx-col w-2/3">
            <v-select v-if="field.type === 'dropdown'" :options="field.options" v-model="field.value" :disabled="field.disabled" class="w-full self-center" placeholder="Select Option From Dropdown..." />
            <vs-input v-if="field.type === 'text'" v-model="field.value" :readonly="field.disabled" class="inputx w-full self-center"/>
            <div class="flex items-center"  v-if="field.type === 'switch'">
              <vs-switch v-model="field.value" :disabled="field.disabled" class="self-center mr-2"/>
            </div>
            <small v-if="field.score === false"
                   class="mt-2 text-danger font-semibold">This answer is incorrect</small>
            <small v-if="field.score === true"
                   class="mt-2 text-success font-semibold">This answer is correct</small>
          </div>
        </div>
      </template>
    </movable-popup>
    <movable-popup refVal="movableRadiusServerRef" title="Juniper Networks AAA Server - Drag Here To Move"
                   :active="radius_server.active" v-on:close="radius_server.active = false">
      <template v-slot:content>
        <div v-for="field in radius_server.properties" :key="field.name" class="vx-row mb-3 mt-3">
          <div class="vx-col flex w-1/3">
            <h3 class="break-words self-center">{{ field.name }}</h3>
          </div>
          <div class="vx-col w-2/3">
            <v-select v-if="field.type === 'dropdown'" :options="field.options" v-model="field.value" :disabled="field.disabled" class="w-full self-center" placeholder="Select Option From Dropdown..." />
            <vs-input v-if="field.type === 'text'" v-model="field.value" :readonly="field.disabled" class="inputx w-full self-center"/>
            <div class="flex items-center"  v-if="field.type === 'switch'">
              <vs-switch v-model="field.value" :disabled="field.disabled" class="self-center mr-2"/>
            </div>
            <small v-if="field.score === false"
                   class="mt-2 text-danger font-semibold">This answer is incorrect</small>
            <small v-if="field.score === true"
                   class="mt-2 text-success font-semibold">This answer is correct</small>
          </div>
        </div>
      </template>
    </movable-popup>

    <movable-popup refVal="movableRadiusServerRef" title="Starbucks Staff Device - Drag Here To Move"
                   :active="wireless_client.active" v-on:close="wireless_client.active = false">
      <template v-slot:content>
        <div v-for="field in wireless_client.properties" :key="field.name" class="vx-row mb-3 mt-3">
          <div class="vx-col flex w-1/3">
            <h3 class="break-words self-center">{{ field.name }}</h3>
          </div>
          <div class="vx-col w-2/3">
            <v-select v-if="field.type === 'dropdown'" :options="field.options" v-model="field.value" :disabled="field.disabled" class="w-full self-center" placeholder="Select Option From Dropdown..." />
            <vs-input v-if="field.type === 'text'" v-model="field.value" :readonly="field.disabled" class="inputx w-full self-center"/>
            <div class="flex items-center"  v-if="field.type === 'switch'">
              <vs-switch v-model="field.value" :disabled="field.disabled" class="self-center mr-2"/>
            </div>
            <small v-if="field.score === false"
                   class="mt-2 text-danger font-semibold">This answer is incorrect</small>
            <small v-if="field.score === true"
                   class="mt-2 text-success font-semibold">This answer is correct</small>
          </div>
        </div>
      </template>
    </movable-popup>

  </div>
</template>

<script>

import Prism from 'vue-prism-component'
import vSelect from 'vue-select'
import MovablePopup from '../../../../../../../../../components/popup/MovablePopup'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      wifi_controller: {
        active: false,
        properties: [
          {
            'name': 'WiFi SSID',
            'type': 'text',
            'value': '',
            'answer': 'SBUX-BYOD-WIFI',
            'disabled': false,
            'score': null
          },
          {
            'name': 'AAA Server Address',
            'type': 'text',
            'value': '',
            'answer': '10.0.100.13',
            'disabled': false,
            'score': null
          },
          {
            'name': 'AAA Server Port Number',
            'type': 'text',
            'value': '',
            'answer': '1812',
            'disabled': false,
            'score': null
          },
          {
            'name': 'PSK',
            'type': 'text',
            'value': '',
            'answer': 'PV6JYNYQ2X',
            'disabled': false,
            'score': null
          },
          {
            'name': 'Authentication Type',
            'type': 'dropdown',
            'value': '',
            'answer': 'WPA2-PSK',
            'disabled': false,
            'options': ['EAP-POTP', 'WPA3', 'OPEN', 'WPA-PSK', 'WEP', 'WPA2-PSK'],
            'score': null
          },
          {
            'name': 'Wireless Channel',
            'type': 'dropdown',
            'value': '',
            'answer': '11',
            'disabled': false,
            'options': ['11', '2', '3', '7', '9', '12'],
            'score': null
          },
          {
            'name': 'Controller Address',
            'type': 'text',
            'value': '10.0.100.51',
            'answer': '10.0.100.51',
            'disabled': true,
            'score': null
          }
        ]
      },

      radius_server: {
        active: false,
        properties: [
          {
            'name': 'Client Address',
            'type': 'text',
            'value': '',
            'answer': '10.0.100.51',
            'disabled': false,
            'score': null
          },
          {
            'name': 'Authentication Type',
            'type': 'dropdown',
            'value': '',
            'answer': 'Microsoft AD',
            'disabled': false,
            'options': ['IPSec', 'L2TP', 'Microsoft AD', 'AWS IAM'],
            'score': null
          },
          {
            'name': 'Server Address',
            'type': 'text',
            'value': '10.0.100.13',
            'answer': '10.0.100.13',
            'disabled': true,
            'score': null
          },
          {
            'name': 'Shared Key',
            'type': 'text',
            'value': 'PV6JYNYQ2X',
            'answer': 'PV6JYNYQ2X',
            'disabled': true,
            'score': null
          }
        ]
      },

      wireless_client: {
        active: false,
        properties: [
          {
            'name': 'SSID',
            'type': 'text',
            'value': 'SBUX-BYOD-WIFI',
            'answer': 'SBUX-BYOD-WIFI',
            'disabled': true,
            'score': null
          },
          {
            'name': 'PSK',
            'type': 'text',
            'value': '',
            'answer': 'PV6JYNYQ2X',
            'disabled': false,
            'score': null
          },
          {
            'name': 'DC NetBIOS Name',
            'type': 'text',
            'value': '',
            'answer': 'SBUX',
            'disabled': false,
            'score': null
          },
          {
            'name': 'Username',
            'type': 'text',
            'value': '',
            'answer': 'staffBYOD',
            'disabled': false,
            'score': null
          },
          {
            'name': 'User Password',
            'type': 'text',
            'value': '',
            'answer': 'STAFFY37LGWSH',
            'disabled': false,
            'score': null
          },
          {
            'name': 'Authentication Type',
            'type': 'dropdown',
            'value': '',
            'answer': 'WPA2-ENTERPRISE',
            'disabled': false,
            'options': ['WPA-ENTERPRISE', 'WPA3', 'WPA2-PERSONAL', 'WPA', 'WPA2-ENTERPRISE', 'WEP', 'OPEN', 'WPA2-PSK'],
            'score': null
          }
        ]
      }

    }
  },
  methods: {
    markSimulation () {

      let total_score = 0

      this.wifi_controller.properties.forEach((field, field_i) => {
        if (field.value === field.answer) {
          this.wifi_controller.properties[field_i].score = true
          total_score++
        } else {
          this.wifi_controller.properties[field_i].score = false
        }
      })

      this.radius_server.properties.forEach((field, field_i) => {
        if (field.value === field.answer) {
          this.radius_server.properties[field_i].score = true
          total_score++
        } else {
          this.radius_server.properties[field_i].score = false
        }
      })

      this.wireless_client.properties.forEach((field, field_i) => {
        if (field.value === field.answer) {
          this.wireless_client.properties[field_i].score = true
          total_score++
        } else {
          this.wireless_client.properties[field_i].score = false
        }
      })


      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    Prism,
    vSelect,
    MovablePopup
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>

<style lang="scss" scoped>

.w-select {
  font-weight: 800;
}

@import "@/views/platform/modules/simulations/legacy/css/CompTIA/Security+/Lgx335452482824044544.scss";

</style>

